// @ts-nocheck
import * as emailApi from '../api/emailApi';

export function getEmailById(id) {
  return emailApi.getEmailById(id);
}

export function loadEmails(params) {
  return emailApi.getEmails(params);
}

export function exportEmailData(filters, scopes) {
  return emailApi.exportEmailData(filters, scopes);
}

export function resendEmail(id) {
  return emailApi.resendEmail(id);
}
